import _ from 'lodash';
import HelperEncryption from "utils/helper-encryption";
import utf8 from 'utf8'
import createAxiosClient from 'utils/request/axios'

const Ajax = {
	request: ( url, { variables = {}, onSuccess, onError, onStart, options = {} } = {} ) => {
		const useJwt = HelperEncryption.isJwtEnabled()
		
		// Options
		const silent = _.get( options, 'silent', false );
		const ignoreAuth = _.get( options, 'ignoreAuth', false );
		const _onUploadProgress = _.get( options, 'onUploadProgress', null );
		
		// Create the params for the post
		let postData = !useJwt ? {} : {
			algorithm: HelperEncryption.getAlgorithm()
		};
		
		for( let [ key, value ] of Object.entries( variables ) ) {
			if( useJwt && key.indexOf( 'non_encoded_' ) === -1 ) {
				key = HelperEncryption.encode( key );
				value = HelperEncryption.encode( value );
			}
			
			postData[ key ] = value;
		}
		
		const onThen = function(response) {
			let data = _.get( response, 'data', {} );
			
			if( typeof data != "object" ) {
				data = JSON.parse( useJwt ? utf8.decode( HelperEncryption.decode( data ) ) : data );
			}
			
			if( "errors" in data ) {
				const errors = data['errors'];
				const message = _.get( errors, [ 0, 'message'], '');
				
				// Overwrite response status
				response.status = 500;
				response.statusText = 'Internal Server Error';
				
				return onCatch( {
					config: response.config,
					message: message,
					response: {
						status: 500,
						data: response
					}
				} );
			}
			
			return onSuccess !== null ? onSuccess( data ) : null;
		};
		
		const onCatch = function(error) {
			if( onError !== null ) {
				return onError( error );
			}
		};
		
		const retry = function() {
			return Ajax.request( url, {
				variables, onSuccess, onError, onStart, options
			} );
		};
		
		// Action to perform BEFORE the axios call
		if( onStart !== null && typeof onStart === 'function' ) {
			onStart();
		}
		
		createAxiosClient({ contentType: 'application/x-www-form-urlencoded', ignoreAuth: ignoreAuth }).then( axiosClient => {
			// Create config
			const config = {};
			if( _onUploadProgress !== null ) {
				config['onUploadProgress'] = _onUploadProgress;
			}
			
			axiosClient
				.post( url, postData, config )
				.then( onThen )
				.catch( onCatch );
		});
	}
}

export default Ajax
